import { NgComponentOutlet } from '@angular/common'
import { Component, computed, inject } from '@angular/core'

import { Store } from '@ngrx/store'

import { AiBuilderToggleComponent } from '@flowx/designer/modules/ai-builder/components/ai-builder-toggle/ai-builder-toggle.component'
import { AiBuilderStore } from '@flowx/designer/modules/ai-builder/store/ai-builder.store'
import { layoutComponentOutlet } from '@flowx/designer/modules/layout/services/layout-injector'
import { FlxProjectHeaderComponent } from '@flowx/designer/modules/projects/components/project-header/project-header.component'
import { WorkspacesSwitchComponent } from '@flowx/designer/modules/workspaces/shared/workspaces-switch/workspaces-switch.component'
import { FlxNotificationsCenterComponent } from '@flowx/designer/shared/components/notifications/notifications-center/notifications-center.component'
import { selectStableRouteArea } from '@flowx/designer/shared/store/selectors/router.selectors'

import { FlxAccountMenuComponent } from './account-menu/account-menu.component'
import { FlxHeaderHomeComponent } from './header-home/header-home.component'

/**
 * The one header above every authenticated page. Its left says where you are and lets you move to
 * a sibling location; its right holds actions. What it shows depends only on the area.
 */
@Component({
  selector: 'flx-global-header',
  imports: [
    NgComponentOutlet,
    AiBuilderToggleComponent,
    FlxHeaderHomeComponent,
    WorkspacesSwitchComponent,
    FlxNotificationsCenterComponent,
    FlxAccountMenuComponent,
  ],
  templateUrl: './global-header.component.html',
  styleUrls: ['./global-header.component.scss'],
  host: {
    // `dark` gives the design-system controls on the bar their dark variants.
    'class': 'dark flex flex-none items-center gap-x-3 px-4 text-xs text-white',
    'role': 'banner',
    'data-testid': 'global-header',
    '[class.ai-rail-docked]': 'aiBuilder.railMounted()',
  },
})
export class FlxGlobalHeaderComponent {
  #store = inject(Store)
  aiBuilder = inject(AiBuilderStore)

  /** From the route a navigation commits to, so one a guard cancels leaves the header as it was. */
  area = this.#store.selectSignal(selectStableRouteArea)

  showSwitcher = computed(() => this.area() === 'workspace')

  /** Created with the project layout's injectors while a project is open. */
  projectHeader = layoutComponentOutlet(FlxProjectHeaderComponent)
}
